
export function addScript({ html: innerHtml = undefined, src, async, location = 'body'  }: { html?: string, src?: string, async?: boolean, location?: 'body' | 'head' }) {
    const script = document.createElement('script');

    if (innerHtml) script.innerHTML = innerHtml;
    if (src) script.src = src;
    if (async) script.async = true;

    if (location === 'body') {
        document.body.appendChild(script);
    } else {
        document.head.appendChild(script);
    }
}
